// client/src/components/auth/SocialAuthButtons.js
import React from 'react'

/**
 * SocialAuthButtons stub - Google auth has been removed from the client.
 * This component intentionally renders nothing to avoid loading external
 * Google scripts and causing runtime issues in environments that don't
 * use Google OAuth.
 */
function SocialAuthButtons() {
  // Keep a small info log to aid debugging
  React.useEffect(() => {
    console.info('[OAuth][Google] Google sign-in disabled in this build')
  }, [])

  return null
}

export default SocialAuthButtons
